import * as model from '../model-states/m-health-history'
import uniqid from 'uniqid'
import * as patient_actions from '../store/patient/actions'
import skip_logic_map from '../assets/json/diseases-skip-logic-map.json';
import { cloneDeep } from 'lodash'

const saveHistoryDetailToRedux = (dispatch, ownerRkey, history_detail) => {
  let payload = {ownerRkey, history_detail}
  dispatch(patient_actions.save_history_detail(payload))
}

const saveHistoryDiseasesToRedux = (dispatch, ownerRkey, history_diseases) => {
  let member_diseases = []

  for(var item of history_diseases) {
    var disease = model.createHistoryDisease()
    disease.id = item.id
    disease.disease_code = item.disease_code
    disease.age_diagnosed = item.age_diagnosed
    disease.age_diagnosed_string = item.age_diagnosed_string
    disease.disease_id = item.disease_id
    disease.disease_name = item.disease_name
    // disease.disease = {value: item.disease_id, label: item.disease_name}
    disease.skip_logics = item.skip_logics
    member_diseases.push(disease)
  }


  let payload = {ownerRkey, history_diseases: member_diseases}
  dispatch(patient_actions.save_history_diseases(payload))
}

const saveHistoryDiseaseDetailToRedux = (dispatch, ownerRkey, history_disease_detail) => {
  let payload = {ownerRkey, history_disease_detail}
  dispatch(patient_actions.save_history_disease_detail(payload))
}

const parseIdOrKey = (str) => {
  try {
      const num = parseInt(str, 10); // Convert string to number

      // Check if the number is an integer and the string is not empty
      if (Number.isInteger(num) && str.trim() !== '') {
          return num; // Return the number if it's a valid integer
      }

      return str; // Return the original string if it's not a valid integer
  }
  catch (e) {
      return str;
  }
}

const saveHistoryGenesToRedux = (dispatch, ownerRkey, history_genes, member_id) => {
  let non_panels = history_genes.non_panels ? history_genes.non_panels : {}
  let panels = history_genes.panels ? history_genes.panels : {}

  let member_genetic_testing = [];
  let member_gene_panels = [];

  for (let key in non_panels) {
      let gene = non_panels[key];
      let gene_data = {
          id: key ? parseIdOrKey(key) : null, // maybe needed to be included on json export
          member_id_id: gene.member_id ? parseIdOrKey(gene.member_id) : null,
          gene_id_id: gene.gene_id ? gene.gene_id : null,
          type: 'type' in gene ? gene.type : null,
          result: gene.result,
          variant: gene.variant,
          status: gene.status,
          umls_id: gene.umls_id,
          umls_name: gene.umls_name,
          testing_panel_id: null, // non panel, so null
          gene_id: gene.umls_id,
          gene: gene.umls_name
      }
      member_genetic_testing.push(gene_data)
  }

  for (let key in panels) {
      let panel = panels[key];
      let panel_genes = panel.panel_genes;
      let member_genes = [];
      for (let gene in panel_genes) {
          let gene_data = panel_genes[gene];
          member_genes.push({
              id: gene ? parseIdOrKey(gene) : null, // maybe needed to be included on json export
              member_id_id: member_id ? parseIdOrKey(member_id) : null,
              gene_id_id: null,
              type: 'type' in gene_data ? gene_data.type : null,
              result: gene_data.result,
              variant: gene_data.variant,
              status: gene_data.status,
              umls_id: gene_data.umls_id,
              umls_name: gene_data.umls_name,
              testing_panel_id: key ? parseIdOrKey(key) : null,
              gene: null,
              gene_id: null
          });
      }

      let panel_data = {
          panel_id: panel.panel_info.panel_id ? parseIdOrKey(panel.panel_info.panel_id) : null,
          panel_tested: panel.panel_info.panel_tested,
          panel_status: panel.panel_info.status,
          panel_date: panel.panel_info.date,
          panel_notes: panel.panel_info.notes,
          testing_panel: key ? parseIdOrKey(key) : null,
          member_genes: member_genes,
          member_id: member_id ? parseIdOrKey(member_id) : null
      }
      member_gene_panels.push(panel_data);
  }

  dispatch(patient_actions.save_history_genes({ownerRkey, history_genes: member_genetic_testing}))
  dispatch(patient_actions.save_history_gene_panels({ownerRkey, history_gene_panels: member_gene_panels}))
}

const saveHistoryGeneDetailToRedux = (dispatch, ownerRkey, history_gene_detail) => {
  let payload = {ownerRkey, history_gene_detail}
  dispatch(patient_actions.save_history_gene_detail(payload))
}

export {
  saveHistoryDetailToRedux,
  saveHistoryDiseasesToRedux,
  saveHistoryDiseaseDetailToRedux,
  saveHistoryGenesToRedux,
  saveHistoryGeneDetailToRedux
}
